import React from "react";
import { useEffect, useState } from "react";
import { EmployeeRecordsVM } from "../../Models/ViewModels";
import * as Employee from "../../Services/EmployeeDB";
import { ToastContainer, toast } from "react-toastify";
import { AnyPtrRecord } from "dns";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import { Row, Table } from "rsuite";
import { CustomTableHeaderCell } from "../../SharedComponents/CustomTableHeaderCell";
import { CustomTableCell } from "../../SharedComponents/CustomTableCell";
const { Column, HeaderCell, Cell, ColumnGroup } = Table;
export const MyTeamInfo = (props: any) => {
  const [cachedEmployeesList, setCachedEmployeesList] = useState(
    new Array<EmployeeRecordsVM>()
  );
  const [loginid, setLoginid] = useState(GetUserLoginID());

  const getTeamRecords = (id: any) => {
    Employee.GetTeamInfo(id)
      .then((res) => {
        if (res.data) {
          setCachedEmployeesList(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getTeamRecords(props.id);
  }, []);
  if (cachedEmployeesList.length > 0) {
    return (
      <>
        {
          <div>
            <b>Teams Associated:</b>

            <Table
              data={cachedEmployeesList}
              rowHeight={31}
              width={660}
              height={140}
              bordered={false}
              headerHeight={30}
              cellBordered={true}
              className="border border-dark"
            >
              <Column width={160} align="center" fixed>
                <CustomTableHeaderCell placement={"Name"}>
                  {" "}
                  Name
                </CustomTableHeaderCell>
                <CustomTableCell dataKey="EmployeeName" />
              </Column>
              <Column width={250} align="center" fixed>
                <CustomTableHeaderCell placement={"Team"}>
                  Team
                </CustomTableHeaderCell>
                <CustomTableCell dataKey="TeamName" />
              </Column>
              <Column width={110} align="center" fixed>
                <CustomTableHeaderCell placement={"SubTeam"}>
                  SubTeam
                </CustomTableHeaderCell>
                <CustomTableCell dataKey="SubTeamName" />
              </Column>
              <Column width={140} align="center" fixed>
                <CustomTableHeaderCell placement={"Process"}>
                  Process
                </CustomTableHeaderCell>
                <CustomTableCell dataKey="ProcessName" />
              </Column>
            </Table>
          </div>
        }
      </>
    );
  } else {
    return <></>;
  }
};
